// extracted by mini-css-extract-plugin
export default {"rentalYieldContainer":"YieldPage_rentalYieldContainer__-y7kd","tableContainer":"YieldPage_tableContainer__mJNrp","tableGroupContainer":"YieldPage_tableGroupContainer__anwwr"};